import React, { useState } from 'react';
import { Nav, Table } from 'react-bootstrap';

import SubtleBadge from 'components/common/SubtleBadge';

import { getShipmentLineBadgeColor } from 'constants/shipment';

const PickedShipmentTable = ({ shipmentData }) => {
  const [activeTab, setActiveTab] = useState('pending');

  const getFilteredLines = () => {
    if (!shipmentData?.lines) return [];

    switch (activeTab) {
      case 'pending':
        return shipmentData.lines.filter(line =>
          ['created', 'picking'].includes(line.shipment_line_status),
        );
      case 'scanned':
        return shipmentData.lines.filter(
          line => line.shipment_line_status === 'picked',
        );
      default:
        return shipmentData.lines;
    }
  };

  return (
    <div>
      <Nav variant="tabs" className="mb-3">
        <Nav.Item>
          <Nav.Link
            active={activeTab === 'pending'}
            onClick={() => setActiveTab('pending')}
          >
            Pending
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            active={activeTab === 'scanned'}
            onClick={() => setActiveTab('scanned')}
          >
            Scanned
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            active={activeTab === 'all'}
            onClick={() => setActiveTab('all')}
          >
            All
          </Nav.Link>
        </Nav.Item>
      </Nav>

      <Table responsive striped>
        <thead>
          <tr>
            <th className="fs-10 text-900">SKU</th>
            <th className="fs-10 text-900">Name</th>
            <th className="fs-10 text-900">Barcode</th>
            <th className="fs-10 text-900 text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          {getFilteredLines().map(line => (
            <tr key={line.id}>
              <td className="fs-10">{line?.product?.sku || '-'}</td>
              <td className="fs-10">{line?.product?.name || '-'}</td>
              <td className="fs-10">{line?.product?.barcode || '-'}</td>
              <td className="text-center">
                <SubtleBadge
                  bg={getShipmentLineBadgeColor(line.shipment_line_status)}
                >
                  {line.shipment_line_status_label}
                </SubtleBadge>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default PickedShipmentTable;
